/*
// Licensed Materials - Property of HCL
// (C) Copyright HCL Technologies Limited 2001, 2021
// All Rights Reserved
*/

import BfHttpClient from '../authClient/BfHttpClient'
import BfCachedRequest from '../utils/BfCachedRequest'
import { map } from 'rxjs/operators'

/**
 * Provides functionalities to fetch patch data
 */
class BfPolicyGroupsService {
  bfCachedRequest = new BfCachedRequest(true)
  http = new BfHttpClient()

  _getParams = (options) => {
    return options
  }
  /**
   * Triggers http request to fetch patch data from server
   * @method
   * @param {Object} options Pagination and Sorting options
   * @returns {Promise} Patch data
   */

  getPolicyGroups(options) {
    const params = this._getParams(options)
    return this.http.get('/api/policyGroups', params).pipe(
      map((data) => {
        return { totalCount: data.count, rows: data.data }
      })
    )
  }
}

export default BfPolicyGroupsService
